import React from 'react';
import PropTypes from 'prop-types';

import {Button, Stack, TextCharLimit, FreeSoloDropdown} from 'views/components';
import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';

import {Translate, translate} from 'views/module';

const ClientLeadNameEdit = (props) => {
  const [contactType, setContactType] = React.useState('');
  const [contactDetail, setContactDetail] = React.useState('');

  const {
    clientLeadBackend,
    isEditing,
    setIsEditing,
  } = props;

  const onSave = () => {
    clientLeadBackend.detail.addContact(contactType, contactDetail, () => {
      setIsEditing(false);
    });
  };

  const isValid = () => {
    return !Boolean(contactType && contactDetail);
  };

  const onClose = () => {
    setIsEditing(false);
  };

  return (
    <Dialog onClose={onClose} open={isEditing}>
      <DialogTitle onClose={onClose}>
        <Translate expression='clientLead.ClientLeadDetail.Settings.Contact.CreateNew.Action' />
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            m: 1,
          }}
          spacing={1}
        >
          <FreeSoloDropdown
            options={[
              translate('clientLead.ClientLeadDetail.Settings.Contact.CreateNew.ContactTypeExample.Email'),
              translate('clientLead.ClientLeadDetail.Settings.Contact.CreateNew.ContactTypeExample.PhoneNumber'),
              translate('clientLead.ClientLeadDetail.Settings.Contact.CreateNew.ContactTypeExample.EmergencyContact'),
            ]}
            label={translate('clientLead.ClientLeadDetail.Settings.Contact.CreateNew.ContactType')}
            onChange={setContactType}
            value={contactType}
          />
          <TextCharLimit
            label={translate('clientLead.ClientLeadDetail.Settings.Contact.CreateNew.ContactDetail')}
            value={contactDetail}
            onChange={setContactDetail}
            charLimit={180}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button color="primary" disabled={isValid()} onClick={onSave}>
          <Translate expression='generic.Save' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ClientLeadNameEdit.propTypes = {
  clientLeadData: PropTypes.object.isRequired,
  clientLeadBackend: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(ClientLeadNameEdit);
